import MarkerCardComp from "./MarkerCardComp";
import * as c from '../../../../constants';
import { useAuth } from "../../../../provider";

const MarkerCard = ({ marker }) => {

return (

  <MarkerCardComp

    marker ={marker}

    />

)
}
export default MarkerCard;

/*
history_url = {`${c.API_URL}/measurements/${userId}/${markerName}`}
    marker_values_url = {`${c.API_URL}/measurements/${userId}/${markerName}/${labvisitDate}/`}  
    marker_url = {`${c.API_URL}/measurements/${userId}/${markerName}/${labvisitDate}/`}
    marker_name = {`markername_${markerName}`}
    marker_description = {`markerdescr_${markerName}`}
    markerchart_title = {`${markerName} - Trend`}
    targetNavigation = "/BloodAllWelcome"
    markertabletitle = {`${markerName} - History`}

    description_key=    {`description_${markerName}`}
    lowtext_key=        {`lowtext_${markerName}`}
    lowrec_key=         {`lowrec_${markerName}`}
    rangetext_key=      {`rangetext_${markerName}`}
    hightext_key=       {`hightext_${markerName}`}
    highrec_key=        {`highrec_${markerName}`}
  */